import { render } from "./UserNavBar.vue?vue&type=template&id=5cb67e81&scoped=true"
import script from "./UserNavBar.vue?vue&type=script&lang=js"
export * from "./UserNavBar.vue?vue&type=script&lang=js"

import "./UserNavBar.vue?vue&type=style&index=0&id=5cb67e81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb67e81"]])

export default __exports__